import { render, staticRenderFns } from "./UserRoleBulkRemoveDialog.vue?vue&type=template&id=a3c2f668&scoped=true"
import script from "./UserRoleBulkRemoveDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleBulkRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleBulkRemoveDialog.vue?vue&type=style&index=0&id=a3c2f668&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c2f668",
  null
  
)

export default component.exports